module.exports = __webpack_public_path__ + "static/media/toonification.9ec11769.gif";